﻿export const Home = (() => {

	const Init = (): void => {
/*

		flatpickr("#MyDate", {
			dateFormat: "j M Y",
			allowInput: true
		});
		*/

		/*document.querySelectorAll('#dtTestButton, #dtTestButton2').forEach(el => {
			el.addEventListener('click', () => {
				var dt = document.getElementById('dtTest') as HTMLInputElement;
				if (dt) {
					if (dt.showPicker) {
						dt.showPicker();
					}
					else {
						dt.focus();
						dt.click();
					}
				}
			});
		})*/
	};

	return { Init };

})();

document.addEventListener('DOMContentLoaded', () => {
	Home.Init();
});